export default __webpack_public_path__ + "static/media/iconCreatedAt.0f9cf98f.svg";